export function redeemErrorCopy(code: string | undefined): {
	titleKey: string;
	messageKey: string;
} {
	if (code === "BONUS_INSUFFICIENT") {
		return {
			titleKey: "catalog.insufficient",
			messageKey: "catalog.insufficientHint",
		};
	}
	if (code === "UNAUTHORIZED" || code === "UNAUTHORIZED_OPERATION") {
		return { titleKey: "catalog.failed", messageKey: "errors.forbidden" };
	}
	if (code === "ENTITY_NOT_FOUND" || code === "NOT_FOUND") {
		return { titleKey: "catalog.failed", messageKey: "catalog.missingReward" };
	}
	return { titleKey: "catalog.failed", messageKey: "errors.generic" };
}
